<template>
	<div class="home" v-loading="loading">
			<el-row  justify="space-between" :gutter="0">
				<el-col :xs="2" :sm="3" :md="4" :lg="5" :xl="6">
					<div style="height: 1px; width: 100%">
					</div>
				</el-col>
				<el-col :xs="20" :sm="18" :md="16" :lg="14" :xl="12">
					<div>
						<contest-card
							:body-style="{ padding: '0px' }"
							class="contest-item"
							v-for="contest in filteredContests" :key="contest.key"
							:id="contest.id"
							:name="contest.name"
							:desc="contest.shortDesc"
							:img="contest.img"
							:creationDate="contest.date"
							:expired="contest.expired"
							:types="contest.types"
							:prize-title="contest.prizeTitle"
							:prize-end-title="contest.prizeEndTitle"
							:prize="contest.prize"
							:prizes="contest.prizes"
							@click="goContest">
						</contest-card>
					</div>
				</el-col>
				<el-col :xs="2" :sm="3" :md="4" :lg="5" :xl="6">
					<div style="height: 1px; width: 100%">
					</div>
				</el-col>
			</el-row>
	</div>
</template>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex'
import ContestCard from '../components/ContestCard.vue';

export default {
	name: 'home',
	components: {
		ContestCard
	},
	data() {
		return {
			loading: false,
			contests: [
				{
					id: 2,
					name: "Torneo VERSUS",
					shortDesc: "Juntate con tu amigo y compitan en este Torneo 2v2 por skins!",
					prizeTitle: "Los ganadores se llevan",
					//prize: "Ganadores primera etapa: Skins de Heimerdinger Veraniego. 1º y 2º puesto: Vayne Flor Espiritual",
					prizes: [
						{
							title: "Equipos que ganen una partida",
							desc: "Skins de Heimerdinger Veraniego"
						},
						{
							title: "Equipos en 1º y 2º puesto",
							desc: "Skin Vayne Flor Espiritual"
						}
					],
					date: "29/07/2020",
					expired: false,
					img: 'http://lolarg.driconmax.com.ar/img/Torneo%202v2.jpg',
					types: [
						{
							id: 1,
							name: "SORTEO",
							color: "#4CB949"
						},
						{
							id: 2,
							name: "TORNEO",
							color: "#BF64BC"
						},
						{
							id: 3,
							name: "VERSUS",
							color: "#AAAA22"
						}
					]
				},
				{
					id: 1,
					name: "Carrera Lunar",
					shortDesc: "Corre en una epica carrera por la grieta del invocador, pero cuidado con Astro Bardo!",
					prizeTitle: "Los ganadores se llevan",
					prizeEndTitle: "Los ganadores se llevaron",
					prize: "Skins de Astro Bardo",
					date: "11/07/2020",
					expired: true,
					img: 'http://lolarg.driconmax.com.ar/img/Carrera%20Lunar%20Logo.jpg',
					types: [
						{
							id: 1,
							name: "SORTEO",
							color: "#CC0000"
						},
						{
							id: 3,
							name: "VERSUS",
							color: "#AAAA22"
						}
					]
				},
				{
					id: 1,
					name: "Carrera Lunar",
					shortDesc: "Corre en una epica carrera por la grieta del invocador, pero cuidado con Astro Bardo!",
					prizeTitle: "Los ganadores se llevan",
					prizeEndTitle: "Los ganadores se llevaron",
					prize: "Skins de Astro Bardo",
					date: "11/07/2020",
					expired: true,
					img: 'http://lolarg.driconmax.com.ar/img/Carrera%20Lunar%20Logo.jpg',
					types: [
						{
							id: 1,
							name: "SORTEO",
							color: "#4CB949"
						},
						{
							id: 2,
							name: "TORNEO",
							color: "#BF64BC"
						},
						{
							id: 3,
							name: "VERSUS",
							color: "#AAAA22"
						}
					]
				},
				{
					id: 1,
					name: "Carrera Lunar",
					shortDesc: "Corre en una epica carrera por la grieta del invocador, pero cuidado con Astro Bardo!",
					prizeTitle: "Los ganadores se llevan",
					prizeEndTitle: "Los ganadores se llevaron",
					prize: "Skins de Astro Bardo",
					date: "11/07/2020",
					expired: true,
					img: 'http://lolarg.driconmax.com.ar/img/Carrera%20Lunar%20Logo.jpg',
					types: [
						{
							id: 1,
							name: "SORTEO",
							color: "#CC0000"
						},
						{
							id: 2,
							name: "TORNEO",
							color: "#AA00AA"
						},
						{
							id: 3,
							name: "VERSUS",
							color: "#AAAA22"
						}
					]
				},
				{
					id: 1,
					name: "Carrera Lunar",
					shortDesc: "Corre en una epica carrera por la grieta del invocador, pero cuidado con Astro Bardo!",
					prizeTitle: "Los ganadores se llevan",
					prizeEndTitle: "Los ganadores se llevaron",
					prize: "Skins de Astro Bardo",
					date: "11/07/2020",
					expired: true,
					img: 'http://lolarg.driconmax.com.ar/img/Carrera%20Lunar%20Logo.jpg',
					types: [
						{
							id: 1,
							name: "SORTEO",
							color: "#CC0000"
						},
						{
							id: 2,
							name: "TORNEO",
							color: "#AA00AA"
						},
						{
							id: 3,
							name: "VERSUS",
							color: "#AAAA22"
						}
					]
				},
			]
		}
	},
	beforeMount() {
		this.loading = true;
		this.contests = [];
		axios({
			method: 'GET',
			url: '/server/contests.php?action=get',
			data: {}
		}).then((response) => {
			if(response.data.error != 0){
				this.$notify.error({
					title: 'Error',
					message: response.data.message,
					offset: 115
				});
			} else {
				this.contests = response.data.data;
				if(this.contests != undefined){
					this.contests.forEach(contest => {
						if(contest.prizes != undefined){
							contest.prizes.forEach(prize => {
								prize.title = decodeURI(prize.title);
							});
						}
					});
				}
			}
		})
		.catch(this.catchAxios)
		.then(() => {
			this.loading = false;
		});
	},
	methods: {
		goContest(id){
			this.$router.push({ name: 'contest', params: { id: id } })
		}
	},
    computed: {
        // mix the getters into computed with object spread operator
        ...mapGetters([
			'username',
			'img',
			'logged'
			// ...
		]),
		filteredContests(){
			return this.contests;
		}
    }
}
</script>

<style scoped>

	.home {
		padding-top: 30px;
	}

	.contest-container {
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-direction: row;
		-ms-flex-direction: row;
		flex-direction: row;
		-webkit-flex-wrap: wrap;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-align-content: center;
		-ms-flex-line-pack: center;
		align-content: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}

	.contest-item {
		width: 100%;
		-webkit-order: 0;
		-ms-flex-order: 0;
		order: 0;
		-webkit-flex: 0 1 auto;
		-ms-flex: 0 1 auto;
		flex: 0 1 auto;
		-webkit-align-self: auto;
		-ms-flex-item-align: auto;
		align-self: auto;
		margin-bottom: 30px;
	}


	.constest-title {
		color: white;
		margin: 0;
	}

	.contest-image-container {
		width: 250px;
		height: 250px;
		transition: all .7s ease-in-out;
		transform: translateX(0%);
		cursor: pointer;
	}

	.contest-image-container:hover {
		transform: translateX(-100%);
	}

	.contest-image {
		float: left;
		position: relative;
	}

	.contest-image-back {
		position: relative;
		top: -100%;
		transform: translateX(100%);
	}
</style>
